import { interpolateRgb } from "d3-interpolate";
import type {
  GetColorForPercentageType,
  GetFileExtensionType,
  onInitializeDropdownWidthType,
  OnSorterType,
} from "./UtilsType";
import type { SortType } from "../components/tabs/TabsMethodsType";
import dayjs from "dayjs";

const percentColors = [
  { pct: 0, color: "rgb(255,99,71)" },
  { pct: 50, color: "rgb(240,230,140)" },
  { pct: 100, color: "rgb(0,128,0)" },
];

export const GetColorForPercentage: GetColorForPercentageType = (pct) => {
  const lower =
    [...percentColors].reverse().find((c) => pct >= c.pct) ?? percentColors[0];
  const upper =
    percentColors.find((c) => pct <= c.pct) ??
    percentColors[percentColors.length - 1];

  if (lower === upper) return lower.color;

  const t = (pct - lower.pct) / (upper.pct - lower.pct);

  return interpolateRgb(lower.color, upper.color)(t);
};

export const onSorter: OnSorterType = (sorter) => {
  let newSortOrder: SortType = null;

  switch (sorter?.field) {
    case "value":
      return (newSortOrder =
        sorter.order === "ascend" ? "VALUE_ASC" : "VALUE_DESC");
    case "frequency":
      return (newSortOrder =
        sorter.order === "ascend" ? "FREQUENCY_ASC" : "FREQUENCY_DESC");
    case "description":
      return (newSortOrder =
        sorter.order === "ascend" ? "DESCRIPTION_ASC" : "DESCRIPTION_DESC");
    case "item":
      return (newSortOrder =
        sorter.order === "ascend" ? "ITEM_ASC" : "ITEM_DESC");
  }
};

export const onInitializeDropdownWidth: onInitializeDropdownWidthType = (
  el,
  dropdownWithBatchRef,
) => {
  if (el) {
    if (!dropdownWithBatchRef.width) {
      const width = el.getBoundingClientRect().width;

      if (width) {
        dropdownWithBatchRef.width = width;
        el.style.width = `${width}px`;
      }
    } else {
      el.style.width = `${dropdownWithBatchRef.width}px`;
    }
  }
  dropdownWithBatchRef.current = el;
};

export const getFileExtension: GetFileExtensionType = (fileName) => {
  const parts = fileName.split(".");
  return parts.length ? parts.pop() : "";
};

export const getPercentage = (value, total) => {
  if (!total || total === 0) return "0%";

  const percent = (value * 100) / total;

  let rounded = Math.round(percent * 1000) / 1000;

  if (rounded === 0 && percent > 0) {
    return "~0%";
  }

  let formatted = rounded.toFixed(3).replace(/\.?0+$/, "") + "%";

  return formatted;
};

export const formatDateWithOrdinal = (date: string) => {
  const d = dayjs(date);
  const day = d.date();

  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  return { d, suffix };
};

export const splitString = (str: string) => {
  const regex = str.includes("; ") ? /;\s+/ : /\s+/;
  return str.split(regex).filter(Boolean).slice(0, 100);
};
